import * as React from "react";
import { createRoot } from "react-dom/client";
import App from "./components/App";
import { FluentProvider, webLightTheme, webDarkTheme } from "@fluentui/react-components";

/* global document, Office, module, require */
const title = "BestPoolSupplies CRM for Outlook";
const rootElement = document.getElementById("container");
const root = createRoot(rootElement);

const isDarkMode = () => {
  let matched = window.matchMedia("(prefers-color-scheme: dark)").matches;
  return matched ? true : false;
};

const sendEmail = async (recipient) => {
  try {
    Office.context.mailbox.displayNewMessageFormAsync({
      toRecipients: [recipient], // Copies the To line from current item
    });
  } catch (error) {
    console.log("sendEmail - Error", error);
  }
};

let officeReady = false;
let settings = null;

const renderApp = (AppComponent) => {
  // Follow the ui theme
  const theme = isDarkMode() ? webDarkTheme : webLightTheme;

  root.render(
    <FluentProvider theme={theme}>
      <AppComponent title={title} sendEmail={sendEmail} settings={settings} />
    </FluentProvider>
  );
};

/* Render application after Office initializes */
Office.onReady(() => {
  officeReady = true;
  settings = Office.context.roamingSettings;
  renderApp(App);
});

if (module.hot) {
  module.hot.accept("./components/App", () => {
    const NextApp = require("./components/App").default;
    if (officeReady) {
      renderApp(NextApp);
    }
  });
}
